module.exports = "\r\n<div class=\"card image-over-card\">\r\n\t<div class=\"card-image\">\r\n\t\t<a href=\"javascript:void(0)\">\r\n\t\t\t<img src=\"{{imgPath}}\" />\r\n\t\t</a>\r\n\t</div>\r\n\t<div class=\"card-block\">\r\n\t\t<h4 class=\"card-title card-title {{align}} m-b-0 m-t-10\">{{title}}</h4>\r\n\t\t<h6 class=\"category text-gray {{align}}\">{{subtitle}}</h6>\r\n\t\t<ng-content select=\"footer\"></ng-content>\r\n\t</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cards/image-over-card/image-over-card.component.html
// module id = ./src/app/shared/components/cards/image-over-card/image-over-card.component.html
// module chunks = main